export { default } from './SpaTreatmentsPage';
